// theirs
import styled from 'styled-components'
// ours
import { SplitTitleAndTextAndImageProps } from '.'
import { respondToRetina, respondToWidth } from '../../../mixins/respondTo'
import { breakpoints, color, typography } from '../../../styles'
import { appendLocationSingle } from '../../../utils/append-location'

export const splitTitleAndTextAndImageBaseClass =
    'split-title-and-text-and-image'

export const StyledSplitTitleAndTextAndImage = styled.div<SplitTitleAndTextAndImageProps>`
    &.${splitTitleAndTextAndImageBaseClass} {
        padding: 0;
        margin: 0;
        position: relative;
        height: 100%;
        width: 100%;
        display: grid;
        z-index: 2;
        grid-template-rows: 1fr 1fr;

        @media (min-width: ${breakpoints.lg}) {
            grid-template-columns: 1fr 1fr;
            grid-template-rows: auto;
        }

        .content-first {
            display: table;
            background-color: ${(props) =>
                props.content.contentBackgroundColor};
            background-image: url(${(props) =>
                appendLocationSingle(
                    'images',
                    props.content.contentBackgroundImageSource
                )});
            background-blend-mode: multiply;
            height:99.9%;
            max-width: 100vw;
        }

        .content-second {
            display: table;
            background: url(${(props) =>
                    appendLocationSingle(
                        'images',
                        props.content.contentSecondBackgroundImageSource
                    )})
                ${(props) => props.content.contentSecondBackgroundColor};
            background-blend-mode: multiply;
            background-size: cover;
            height:99.9%;
            max-width: 100vw;
        }

        .content-outer {
            display: table-cell;
            vertical-align: middle;
            padding-top: 10%;
        }

        .content-inner {
            max-width: 550px;
            margin: 0 auto;

            @media (min-width: ${breakpoints.lg}) {
                min-height: 250px;
            }
        }

        .title-wrapper {
            display: block;
        }

        h2 {
            font-family: ${typography.type.secondary};
            font-weight: ${typography.weight.bold};
            font-style: ${typography.style.normal};

            color: ${color.lightest};
            text-transform: uppercase;
            text-align: ${(props) =>
                props.content.contentTextInnerAlignment?.toLocaleLowerCase()};
            margin: 0 auto 0 auto;
            padding: 0;

            letter-spacing: normal;
            line-height: normal;

            font-size: ${typography.size.l4};
            ${respondToWidth.xs`
            font-size: ${typography.size.code};
        `}

            ${respondToWidth.lg`
            margin-bottom: 0;
        `}

        ${respondToWidth.xl`
            font-size: ${typography.size.code2};
        `}

        ${respondToRetina.xxxxl`
            font-size: ${typography.size.code3};
        `}
        }

        .text-wrapper {
            margin-bottom: 2.5rem;
            padding: 0 1rem;

            p {
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.64;
                letter-spacing: 0.88px;
                text-align: ${(props) =>
                    props.content.contentTextInnerAlignment?.toLocaleLowerCase()};
                color: ${color.cultured};

                font-size: ${typography.size.s2};
                @media (min-width: ${breakpoints.xs}) {
                    font-size: ${typography.size.s3};
                }
            }
        }
    }
`
